import React from 'react';
import useStore from '../store/useStore';


function DisplayConfiguration({ maxLEDWidth, maxLEDHeight, setMaxLEDWidth, setMaxLEDHeight, panelDetails, setError, errorDisplay, setErrorDisplay }) {

  
    const unit = useStore((state) => state.unit);
    const wallWidth = useStore((state) => state.wallWidth);
    const setWallWidth = useStore((state) => state.setWallWidth);
    const wallHeight = useStore((state) => state.wallHeight);
    const setWallHeight = useStore((state) => state.setWallHeight);
    
    const expandToFitWall = () => {
        const maxColumns = Math.floor(wallWidth / panelDetails.panelWidth);
        const maxRows = Math.floor(wallHeight / panelDetails.panelHeight);
        setMaxLEDWidth(maxColumns * panelDetails.panelWidth);
        setMaxLEDHeight(maxRows * panelDetails.panelHeight);
        //setError('');
        setErrorDisplay('');
    };

    return (
        <div className="custom-border-color p-4 pb-0 mt-3">
          <h4>Display Configuration</h4><hr/>
            <div className="row mb-3">
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3">
                <div className="fw-bold mt-2" id="text-primary">Columns</div>
                </div>
                <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-6">
                <button className="btn" id="btn-primary" onClick={() => {
                    if((maxLEDWidth - panelDetails.panelWidth) >= panelDetails.panelWidth){
                        setMaxLEDWidth(maxLEDWidth - parseFloat(panelDetails.panelWidth));
                        setErrorDisplay('');
                    }else{
                        setMaxLEDWidth(parseFloat(panelDetails.panelWidth));
                    }setError('');
                    }}>-</button>
                    <input type="text" id="input-columns" className="text-center mx-2" value={(maxLEDWidth / panelDetails.panelWidth).toFixed(0)} style={{ width: '100px' }} readOnly={true} />
                    <button className="btn" id="btn-primary" onClick={() => {
                        if (wallWidth >= (maxLEDWidth + panelDetails.panelWidth)) {
                            setMaxLEDWidth(maxLEDWidth + panelDetails.panelWidth);
                            setErrorDisplay('');
                        }else{//setError('');
                            //setErrorDisplay('Please Adjust Wall *Height to Fit in More Displays Cols/Rows.');
                            
                            if(100 >= maxLEDWidth + panelDetails.panelWidth){
                                setWallWidth(maxLEDWidth + panelDetails.panelWidth);
                                setMaxLEDWidth(maxLEDWidth + panelDetails.panelWidth);
                            }else{
                                setError('You are reaching the Max Wall Width!');
                            }
                        }
                    }}>+</button>
                </div>
                <div className="col-12 col-sm-3 mt-1">{(unit === 'ft' ? maxLEDWidth : maxLEDWidth * 0.3048).toFixed(2)} ({unit})</div>
            </div>
            <div className="row mb-3">
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3">
                <div className="fw-bold mt-2" id="text-primary">Rows</div>
                </div>
                <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-6">
                <button className="btn" id="btn-primary" onClick={() => {
                    if((maxLEDHeight - panelDetails.panelHeight) >= panelDetails.panelHeight){
                    setMaxLEDHeight(maxLEDHeight - panelDetails.panelHeight);
                    setErrorDisplay('');
                    }else{
                    setMaxLEDHeight(panelDetails.panelHeight);
                    }setError('');
                }}>-</button>
                <input type="text" id="input-rows" className="text-center mx-2"  value={(maxLEDHeight / panelDetails.panelHeight).toFixed(0)} style={{ width: '100px' }} readOnly={true} />
                <button className="btn" id="btn-primary" onClick={() => {
                    if (wallHeight >= (maxLEDHeight + panelDetails.panelHeight)) {
                        setMaxLEDHeight(maxLEDHeight + panelDetails.panelHeight);
                        //setErrorDisplay('');
                    }else{
                        if(100 >= maxLEDHeight + panelDetails.panelHeight){
                            setWallHeight(maxLEDHeight + panelDetails.panelHeight);
                            setMaxLEDHeight(maxLEDHeight + panelDetails.panelHeight)
                            setError('');
                        }else{
                            setError('You are reaching the Max Wall Height!');
                        }
                    }
                }}>+</button>
                </div>
                <div className="col-12 col-sm-3">{(unit === 'ft' ? maxLEDHeight : maxLEDHeight * 0.3048).toFixed(2)} ({unit})</div>
                {errorDisplay && <div className="mb-3" style={{ color: 'red', fontWeight : 'bold', textAlign: 'center' }}>{errorDisplay}</div>}
                <div className="col-sm-5"></div><button className="btn mt-3 mb-2" id="btn-fit-to-wall" onClick={expandToFitWall}>Fit to Wall</button>  
            </div>
        </div>

    );
}

export default DisplayConfiguration;
